import { Link } from "@material-ui/core";
import { Button } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import DataGridTamplet from "../../Helper/TableTemplet/DataGridTamplet";
import {
  getCases,
  emptyCases,
  updateStatusCase,
} from "./CaseUtils";
import "./GeneralCases.scss";
import caseTypes from "../../../configs/caseTypeConfig";
import { getCaseTypeFormat } from "../SubmitCases/SubmitCases";
import { useTranslation } from "react-i18next";
import { permissions } from "../../../configs/permissions";


const CaseStatusNames = {
  closed: "Closed",
  awaiting: "Answered",
  reimbursed: "Reimbursed",
  opened: "Pending"
};

const screenType = 'general';

const GeneralCases = () => {
  const { t } = useTranslation("generalCases");
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const userRole = useSelector((state: any) => state.general.userRol);
  const case_type = searchParams.get("type");
  const defaultAccount = useSelector(
    (state: any) => state.account.default_account
  );
  const cases = useSelector((state: any) => state.case.cases_list);
  let casesTypeList = useSelector((state: any) => state.general.case_types);
  let isAryehAnalyst = useSelector((state: any) => state.account.is_aryeh_analyst);
  const [queryParams, setQueryParams] = useState({});
  const [filtersValues, setFiltersValues] = useState({ categoryType: "", fieldText: "" });

  const allPermissions = useSelector((s: any) => s.general.user || {})?.permissions || [];
  const isPartner = useSelector((state: any) => state.partner.isPartnerLoggedIn);

  const can = (p: string) => {
    if (!isPartner) return true;
    return allPermissions.includes(p);
  }

  const canViewCaseLink = can(permissions.VIEW_CASE_VIEW_COLUMN);

  useEffect(() => {
    if (defaultAccount && defaultAccount.id) {
      const params = {
        account_id: defaultAccount.id,
        status_case_type: case_type,
      };
      setQueryParams(params);
      getCases(dispatch, params, screenType);
    }
  }, [defaultAccount, case_type]);

  useEffect(() => () => emptyCases(dispatch), [case_type]);

  const search = (list, inputValue) => {
    const isMissingInbound = filtersValues['categoryType'] === "Lost Inbound";

    const params = {
      account_id: defaultAccount.id,
      status_case_type: case_type,
      fieldText: inputValue,
      categoryType: filtersValues['categoryType'],
      filterBy: isMissingInbound ? "SKU" : "FNSKU" // Add this parameter to specify the filtering type
    };
    setQueryParams(params)
    getCases(dispatch, params, screenType);

    // var filteredCses;
    // filteredCasesa =
    //   filtersValues["categoryType"] != ""
    //     ? list.filter(
    //       (item) => item.case_type === filtersValues["categoryType"]
    //     )
    //     : list;
    // return autotomaticSearch(filteredCases, inputValue);
  };

  // const autotomaticSearch = (list, value) => {
  //   var filteredCases =
  //     value != ""
  //       ? list.filter(
  //         (item) =>
  //           (item.case_number && item.case_number.startsWith(value)) ||
  //           item.fnsku_list.filter((fnsku) => fnsku.startsWith(value))
  //             .length > 0
  //       )
  //       : list;
  //   return filteredCases;
  // };

  const baseColumns: GridColDef[] = [
    {
      field: "created_at",
      headerName: t("case_opened"),
      sortable: true,
      width: 140,
    },
    {
      field: "case_number",
      headerName: t("case_number"),
      sortable: true,
      width: 140,
    },
    {
      field: "case_type", headerName: t("type"),
      sortable: true, width: 170, valueGetter: getCaseTypeFormat, hide: isAryehAnalyst
    },
    // { field: "alerts", headerName: "Alerts", sortable: true, width: 100 },
    {
      field: "est_value",
      headerName: t("est_value"),
      sortable: true,
      width: 120,
      type: "number",
      valueFormatter: ({ value }) => value && value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
  ];


  const viewColumn: GridColDef = {
    field: "view",
    headerName: t("view"),
    width: 90,
    renderCell: (params: GridRenderCellParams) => (
      <strong>
        <Link
          href={
            "https://sellercentral.amazon.com/cu/case-dashboard/view-case?caseID=" +
            params.row.case_number
          }
          className="blue-color"
          target="_blank"
        >
          {t("view")}
        </Link>
      </strong>
    ),
  };

  const columns = [
    ...baseColumns,
    ...(canViewCaseLink ? [viewColumn] : [])];

  const extendColumns = [
    ...columns,
    {
      field: "change_status",
      headerName: t("change_status"),
      width: 320,
      renderCell: (params: GridRenderCellParams) => (
        <strong>
          <Button
            variant="outlined"
            size="small"
            className="pending-btn"
            tabIndex={params.hasFocus ? 0 : -1}
            onClick={() => updateStatusCaseDB(params.id, "opened")}
          >
            {t("pending")}
          </Button>
          <Button
            variant="outlined"
            size="small"
            className="reimbursed-btn"
            tabIndex={params.hasFocus ? 0 : -1}
            onClick={() => updateStatusCaseDB(params.id, "reimbursed")}
          >
            {t("reimbursed")}
          </Button>
          <Button
            variant="outlined"
            size="small"
            className="closed-btn"
            tabIndex={params.hasFocus ? 0 : -1}
            onClick={() => updateStatusCaseDB(params.id, "closed")}
          >
            {t("closed")}
          </Button>
        </strong>
      ),
    },
    {
      field: "dismiss",
      headerName: t("dismiss"),
      width: 150,
      renderCell: (params: GridRenderCellParams) => (
        <strong>
          <Button
            variant="text"
            size="small"
            className="red-color"
            tabIndex={params.hasFocus ? 0 : -1}
            onClick={() => dismissCase(params.id)}
          >
            {t("dismiss")}
          </Button>
        </strong>
      ),
    }
  ];

  let filters = [
    {
      id: "categoryType",
      name: t("category_type"),
      values: casesTypeList.map((caseType) => {
        const caseTypeConfig = caseTypes[caseType.name];
        if (!caseTypeConfig) {
          console.warn(`Missing configuration for case type: ${caseType.name}`);
          return { value: caseType.name, label: t("unknown") };
        }
        return { value: caseType.name, label: caseTypeConfig.title };
      }),
    },
  ];

  // Dynamically set the textFieldLabel based on the selected categoryType
  const textFieldLabel = filtersValues.categoryType === "Lost Inbound" ? t("search_by_sku") : t("search_by_fnsku");



  //const textFieldLabel = "Search by Case Number or by product FNSKU";

  const dismissCase = (case_id) => {
    updateStatusCase(dispatch, case_id, 'dismissed', queryParams, screenType);
  };

  const updateStatusCaseDB = (case_id, status) => {
    updateStatusCase(dispatch, case_id, status, queryParams, screenType);
  };
  const getTitle = () => {
    if (case_type) {
      const types = case_type.split(',').map(t => t.trim()).filter(Boolean);
      if (types.length === 1)
        return t(`cases_${types[0]}`);
    }
    return t("cases_log");
  };
  return (
    <div>
      <h2>{getTitle()}</h2>
      <DataGridTamplet
        columns={userRole === 'account' ? columns : extendColumns}
        rows={cases}
        filters={filters}
        onSearch={search}
        textFieldLabel={textFieldLabel}
        selectedFiltersValues={filtersValues}
        setSelectedFiltersValues={setFiltersValues}
        filterInClientSide={false}
      ></DataGridTamplet>
    </div>
  );
};
export default GeneralCases;
